import flatpickr from 'flatpickr';
import 'flatpickr/dist/flatpickr.min.css';

document.addEventListener('DOMContentLoaded', () => {
  if (!document.body.classList.contains('page-template-page-seminar')) {
    return;
  }

  const dateInput = document.querySelector('#seminar-datumInput');
  if (dateInput) {
    flatpickr(dateInput, {
      dateFormat: 'd.m.Y',
      disableMobile: true,
      onChange: function(dates, str) {
        fetchShipEvents(str);
      }
    });
  }

  // Enable the anlass select after page load
  const anlassSelect = document.querySelector('.anlass--select');
  if (anlassSelect) {
    anlassSelect.removeAttribute('disabled');
    console.log('Enabled anlass--select');
  } else {
    console.warn('anlass--select not found during initialization');
  }

  initializePersonsInput();
  setupEventListeners();
  updateTabState();
  updateValues();
  
  // Check for existing date selection on page load
  const existingDate = document.querySelector('#seminar-datumInput')?.value;
  if (existingDate) {
    fetchShipEvents(existingDate);
  }

  const stationSelect = document.querySelector('.station--select');
  if (!stationSelect) {
    console.error('Station select (.station--select) not found in DOM.');
  }

  const navItems = document.querySelectorAll('.seminar-step--nav-item');
  navItems.forEach(item => {
    item.addEventListener('click', (e) => {
      const stepId = item.getAttribute('data-step');
      if (item.classList.contains('blocked')) {
        e.preventDefault();
        return;
      }
      navItems.forEach(nav => nav.classList.remove('active', 'unlocked-inactive'));
      item.classList.add('active');
      document.querySelectorAll('.seminar-step--section').forEach(section => section.classList.remove('active'));
      document.querySelector(`#seminar-step-${stepId}`).classList.add('active');
      navItems.forEach(nav => {
        if (!nav.classList.contains('active') && !nav.classList.contains('blocked')) {
          nav.classList.add('unlocked-inactive');
        }
      });
    });
  });

  const nextButton = document.querySelector('.seminar-step--next');
  if (nextButton) {
    nextButton.addEventListener('click', (e) => {
      if (nextButton.classList.contains('blocked')) {
        e.preventDefault();
        return;
      }
      const stepId = nextButton.getAttribute('data-step');
      document.querySelectorAll('.seminar-step--nav-item').forEach(nav => nav.classList.remove('active', 'unlocked-inactive'));
      const targetNav = document.querySelector(`.seminar-step--nav-item[data-step="${stepId}"]`);
      targetNav.classList.add('active');
      document.querySelector('#seminar-step-1').classList.remove('active');
      document.querySelector(`#seminar-step-${stepId}`).classList.add('active');
      navItems.forEach(nav => {
        if (!nav.classList.contains('active') && !nav.classList.contains('blocked')) {
          nav.classList.add('unlocked-inactive');
        }
      });
      const seminarStep2 = document.querySelector('#seminar-step-2');
      if (seminarStep2) {
        const offsetTop = seminarStep2.getBoundingClientRect().top + window.pageYOffset;
        window.scrollTo({ top: offsetTop - 290, behavior: 'smooth' });
      }
    });
  }
});

function initializePersonsInput() {
  const personsInput = document.querySelector('#seminar-personsInput');
  if (personsInput) {
    personsInput.value = '25';
  }
}

function setupEventListeners() {
  const inputs = document.querySelectorAll('#seminar-step-1 input, #seminar-step-1 select');
  inputs.forEach(input => {
    input.addEventListener('input', () => {
      updateValues();
      updateTabState();
    });
    input.addEventListener('change', () => {
      updateValues();
      updateTabState();
    });
  });

  const anlassSelect = document.querySelector('.anlass--select');
  if (anlassSelect) {
    anlassSelect.addEventListener('change', handleAnlassChange);
  }
  

}

function handleAnlassChange() {
  const anlassSelect = document.querySelector('.anlass--select');
  if (!anlassSelect || !anlassSelect.selectedOptions[0]) {
    console.warn('Anlass select or selected option not found');
    return;
  }

  const selectedOption = anlassSelect.selectedOptions[0];
  const redirectUrl = selectedOption.dataset.redirect;
  const offertenrechnerSeminar = anlassSelect.dataset.offertenrechnerSeminar;
  const anlassValue = anlassSelect.value;

  // Log for debugging
  console.log('handleAnlassChange:', {
    selectedValue: anlassValue,
    redirectUrl: redirectUrl,
    offertenrechnerSeminar: offertenrechnerSeminar,
    currentPath: window.location.pathname,
    isSeminarPage: document.body.classList.contains('page-template-page-seminar')
  });

  // Prevent redirection if on seminar page and redirectUrl matches seminar calculator
  if (
    redirectUrl &&
    document.body.classList.contains('page-template-page-seminar') &&
    redirectUrl === offertenrechnerSeminar &&
    redirectUrl === window.location.pathname
  ) {
    console.log('No redirection needed: Already on seminar page with matching URL');
    return;
  }

  // Redirect to the appropriate page with anlass query parameter
  if (redirectUrl && anlassValue) {
    const url = `${redirectUrl}?anlass=${encodeURIComponent(anlassValue)}`;
    console.log('Redirecting to:', url);
    window.location.href = url;
  } else {
    console.warn('No redirection: Invalid redirectUrl or anlassValue');
  }
}

function validateInputs() {
  const anlassSelect = document.querySelector('.anlass--select')?.value;
  const stationSelect = document.querySelector('.station--select')?.value;
  const durationInput = document.querySelector('#seminar-durationInput')?.value;
  const personsInput = document.querySelector('#seminar-personsInput')?.value;
  const dateInput = document.querySelector('#seminar-datumInput')?.value;

  return (
    anlassSelect && anlassSelect !== '' &&
    stationSelect && stationSelect !== '' &&
    durationInput && durationInput !== '' &&
    personsInput && personsInput !== '' &&
    dateInput && dateInput !== ''
  );
}

function updateTabState() {
  const secondTab = document.querySelector('.seminar-step--nav-item[data-step="2"]');
  const nextButton = document.querySelector('.seminar-step--next');
  const isValid = validateInputs();

  if (secondTab && nextButton) {
    if (isValid) {
      secondTab.classList.remove('blocked');
      nextButton.classList.remove('blocked');
      if (!secondTab.classList.contains('active')) {
        secondTab.classList.add('unlocked-inactive');
      }
    } else {
      secondTab.classList.add('blocked');
      secondTab.classList.remove('unlocked-inactive');
      nextButton.classList.add('blocked');
    }
  }
}

function updateValues() {
  updateDisplay();
  const price = calculatePrice();
  updatePriceDisplay(price);
  updateOver45Message();
  copyToForm();
}

function updateDisplay() {
  const anlassSelect = document.querySelector('.anlass--select');
  const shipInput = document.querySelector('#seminar-ship')?.value || 'LS Stäfa';
  const stationSelect = document.querySelector('.station--select');
  const durationSelect = document.querySelector('#seminar-durationInput');
  const personsSelect = document.querySelector('#seminar-personsInput');
  const dateInput = document.querySelector('#seminar-datumInput')?.value || '';

  const anlassDisplay = document.querySelector('.anlass--display');
  const shipDisplay = document.querySelector('.seminar--ship-display');
  const stationDisplay = document.querySelector('.seminar-station-display');
  const durationDisplay = document.querySelector('.seminar-duration-display');
  const personsDisplay = document.querySelector('.seminar-persons-display');
  const dateDisplay = document.querySelector('.seminar-datum-display');

  if (anlassDisplay) anlassDisplay.textContent = anlassSelect?.selectedOptions[0]?.text || 'Bitte wählen';
  if (shipDisplay) shipDisplay.textContent = shipInput;
  if (stationDisplay) stationDisplay.textContent = stationSelect?.value || 'Bitte wählen';
  if (durationDisplay) durationDisplay.textContent = durationSelect?.selectedOptions[0]?.text || 'Bitte wählen';
  if (personsDisplay) personsDisplay.textContent = personsSelect?.selectedOptions[0]?.text || 'Bitte wählen';
  if (dateDisplay) dateDisplay.textContent = dateInput;
}

function calculatePrice() {
  const stationSelect = document.querySelector('.station--select');
  const duration = parseFloat(document.querySelector('#seminar-durationInput')?.value) || 0;
  const persons = document.querySelector('#seminar-personsInput')?.value;

  if (stationSelect?.value && duration && persons && persons !== 'over_45') {
    let prices;
    try {
      prices = JSON.parse(stationSelect.selectedOptions[0].dataset.prices || '{}');
    } catch (e) {
      console.error('Error parsing data-prices:', e);
      return 0;
    }

    let price = 0;
    if (duration === 5.5) {
      if (persons === '25') {
        price = prices.halber_tag_25 || 0;
      } else if (persons === '35') {
        price = prices.halber_tag_35 || 0;
      } else if (persons === '45') {
        price = prices.halber_tag_45 || 0;
      }
    } else if (duration === 11) {
      if (persons === '25') {
        price = prices.ganzer_tag_25 || 0;
      } else if (persons === '35') {
        price = prices.ganzer_tag_35 || 0;
      } else if (persons === '45') {
        price = prices.ganzer_tag_45 || 0;
      }
    }

    return price;
  }
  return null;
}

function formatSwissPrice(number) {
  const parts = number.toFixed(2).split('.');
  const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, "'");
  return `${integerPart}.${parts[1]}`;
}

function updatePriceDisplay(price) {
  const totalPriceElements = document.querySelectorAll('.total--price');
  const lang = document.documentElement.lang.slice(0, 2);
  const onRequestText = lang === 'en' ? 'On request' : 'Auf Anfrage';
  const configureText = lang === 'en' ? 'Please configure' : 'Bitte konfigurieren';
  const isValid = validateInputs();

  totalPriceElements.forEach(totalPrice => {
    totalPrice.textContent = price !== null ? formatSwissPrice(price) : onRequestText;
  });

  document.querySelectorAll('.show--if--price').forEach(showPrice => {
    showPrice.classList.toggle('block', price !== null && price > 0);
    showPrice.classList.toggle('hidden', !(price !== null && price > 0));
  });

  document.querySelectorAll('.hide--if--price').forEach(hidePrice => {
    const textElement = hidePrice.querySelector('p');
    if (textElement) {
      textElement.textContent = price === null && isValid ? onRequestText : configureText;
    }
    hidePrice.classList.toggle('block', price === null || price <= 0 || !isValid);
    hidePrice.classList.toggle('hidden', price !== null && price > 0 && isValid);
  });
}

function updateOver45Message() {
  const persons = document.querySelector('#seminar-personsInput')?.value;
  const messageContainers = document.querySelectorAll('.show--if--over-45');

  messageContainers.forEach(container => {
    const threshold = container.querySelector('.personsThreshold')?.textContent;
    const shouldShow = persons === threshold;
    container.classList.toggle('hidden', !shouldShow);
    container.classList.toggle('grid', shouldShow);
  });
}

function copyToForm() {
  const anlass = document.querySelector('.anlass--select')?.selectedOptions[0]?.text || '';
  const ship = document.querySelector('#seminar-ship')?.value || '';
  const station = document.querySelector('.station--select')?.value || '';
  const duration = document.querySelector('#seminar-durationInput')?.value || '';
  const durationText = document.querySelector('#seminar-durationInput')?.selectedOptions[0]?.text || '';
  const persons = document.querySelector('#seminar-personsInput')?.value || '';
  const personsText = document.querySelector('#seminar-personsInput')?.selectedOptions[0]?.text || '';
  const date = document.querySelector('#seminar-datumInput')?.value || '';
  const price = calculatePrice();
  const lang = document.documentElement.lang.slice(0, 2);
  const onRequestText = lang === 'en' ? 'On request' : 'Auf Anfrage';
  const formattedPrice = price !== null ? formatSwissPrice(price) : onRequestText;
  const unformattedPrice = price !== null ? price.toFixed(2) : onRequestText;

  const fields = {
    '#input_3_28': anlass,
    '#input_3_16': ship,
    '#input_3_17': station,
    '#input_3_21': durationText,
    '#input_3_19': personsText,
    '#input_3_23': date,
    '#input_3_22': formattedPrice,
    '#input_3_27': unformattedPrice,
  };

  Object.entries(fields).forEach(([selector, value]) => {
    const input = document.querySelector(selector);
    if (input) input.value = value;
  });
}

function fetchShipEvents(selectedDate) {
  if (!selectedDate) {
    console.log('No date selected');
    hideAvailability();
    return;
  }

  // Seminar page only uses LS Stäfa (ship ID 27)
  const shipId = 27;
  const shipValue = 'LS Stäfa';

  // Check if AJAX variables are available
  if (typeof ship_events_ajax === 'undefined') {
    console.error('AJAX configuration not found');
    return;
  }

  // Create FormData for the AJAX request
  const formData = new FormData();
  formData.append('action', 'get_ship_events');
  formData.append('ship', shipId);
  formData.append('date', selectedDate);
  formData.append('nonce', ship_events_ajax.nonce);

  // Make the AJAX request
  fetch(ship_events_ajax.ajax_url, {
    method: 'POST',
    body: formData
  })
  .then(response => response.json())
  .then(data => {
    console.log('Ship events response:', data);
    
    if (data.success) {
      console.log('Debug info:', data.data.debug);
      console.log('Events found for ship ' + shipValue + ' on ' + selectedDate + ':', data.data.events);
      
      // Display availability information
      displayAvailability(data.data.events, selectedDate);
      
      if(data.data.events.length > 0) {
        // Log each event details
        data.data.events.forEach((event, index) => {
          console.log(`Event ${index + 1}:`, {
            id: event.id,
            title: event.title,
            startDate: event.start_date,
            startTime: event.start_time,
            endDate: event.end_date,
            endTime: event.end_time,
            allDay: event.allday
          });
        });
        
      }
    } else {
      console.log('No events found or error occurred');
      hideAvailability();
    }
  })
  .catch(error => {
    console.error('Error fetching ship events:', error);
  });
}

function displayAvailability(events, selectedDate) {
  let availabilityDiv = document.querySelector('#seminar-availability-info');
  
  if (!availabilityDiv) {
    // Create the availability div if it doesn't exist
    availabilityDiv = document.createElement('div');
    availabilityDiv.id = 'seminar-availability-info';
    availabilityDiv.className = 'mt-4';
    
    // Insert after the date input
    const dateInput = document.querySelector('#seminar-datumInput');
    if (dateInput && dateInput.parentNode) {
      dateInput.parentNode.insertBefore(availabilityDiv, dateInput.nextSibling);
    }
  }
  
  if (events.length > 0) {
    // Get language from HTML lang attribute
    const htmlLang = document.documentElement.getAttribute('lang');
    const isEnglish = htmlLang === 'en-US';
    
    // Translations
    const translations = {
      de: {
        availability: `Verfügbarkeit am ${selectedDate}`,
        reservation: 'Bestehende Reservation:',
        allDay: 'ganztägig',
        fromTime: 'ab',
        noTime: 'Zeit nicht angegeben'
      },
      en: {
        availability: `Availability on ${selectedDate}`,
        reservation: 'Existing Reservation:',
        allDay: 'all day',
        fromTime: 'from',
        noTime: 'Time not specified'
      }
    };
    
    const t = isEnglish ? translations.en : translations.de;
    
    // Show availability div with events
    let content = `<p class="text-12 font-semibold">${t.availability}</p>`;
    
    events.forEach(event => {
      let timeRange = '';
      if (event.start_time && event.end_time) {
        timeRange = `${event.start_time} - ${event.end_time}`;
      } else if (event.start_time) {
        timeRange = `${t.fromTime} ${event.start_time}`;
      } else if (event.allday === '1') {
        timeRange = t.allDay;
      } else {
        timeRange = t.noTime;
      }
      
      content += `<p class="text-12">${t.reservation} ${timeRange}</p>`;
    });
    
    availabilityDiv.innerHTML = content;
    availabilityDiv.style.display = 'block';
  } else {
    // Hide availability div if no events
    hideAvailability();
  }
}

function hideAvailability() {
  const availabilityDiv = document.querySelector('#seminar-availability-info');
  if (availabilityDiv) {
    availabilityDiv.style.display = 'none';
  }
}